import React from 'react';
import './vote.css';
import { Paragraph } from '../../../components/paragraph';
import { IconButton } from '../../../components/icon-button';

const Vote = props => {
    const { topic, voteAye, voteNo, modalVisible } = props;

    return (
        <div className="vote">
            <Paragraph colorScheme="dark" withSpacing={false} withIndent={true}>
                About the Bill: {topic.notes}
            </Paragraph>
            <Paragraph colorScheme="dark" withSpacing={true} withIndent={true}>
                Things to consider: {topic.description}
            </Paragraph>
            <div className="vote__decisions">
                <div className="vote__decision">
                    <Paragraph
                        colorScheme="dark"
                        withSpacing={false}
                        textAlign="center"
                    >
                        Vote No
                    </Paragraph>
                    <IconButton
                        onClick={voteNo}
                        iconName="cross"
                        size="small"
                        withSpacing={true}
                        isDisabled={modalVisible}
                        altText="vote no"
                    />
                </div>
                <div className="vote__decision">
                    <Paragraph
                        colorScheme="dark"
                        withSpacing={false}
                        textAlign="center"
                    >
                        Vote Aye
                    </Paragraph>
                    <IconButton
                        onClick={voteAye}
                        iconName="tick"
                        size="small"
                        withSpacing={true}
                        isDisabled={modalVisible}
                        altText="vote aye"
                    />
                </div>
            </div>
        </div>
    );
};

export { Vote };
